import styled, { css } from 'styled-components';

export const PartyJackpotWelcomePopupTitleBox = styled.div<{hasBothTitleAndSubtitle?: boolean}>`
    text-align: center;
    white-space: pre-line;
    font-size: 1.5em;
    font-family: ${props => props.theme.font.family.bold};
    ${props => props.hasBothTitleAndSubtitle ? css`
        color: ${props.theme.components.partyJackpotInGameWidget.colors.amount};
    ` : null}
`;
